<template>
	<div>
		<titles titlename="专业管理" titlecontent="这里可以管理专业" :mbx="paths"></titles>
		<manges :pagesobj="pagesobj" :tabtitlelist="tabtitlelsit" :mangesname="mangesname" :tablist="tablist"></manges>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import manges from '@/components/mangeslist/manges.vue';
import { getPageProfList } from '@/request/api/mange/mange.js';

export default {
	data() {
		return {
			mangesname: {
				name: '专业',
				topcolor: '#FF9528',
				contentcolor: '#88C241',
				show: false
			},
			tabtitlelsit: [
				{
					label: '专业名称',
					prop: 'pro_name'
				},
				{
					label: '备注',
					prop: 'pro_remark'
				},
				{
					label: '创建时间',
					prop: 'pro_createTime'
				}
			],

			tablist: [],

			pagesobj: {
				pageIndex: 1,
				pageSize: 10,
				pro_name: '',
				maxpages: null
			},
			// 标题组件
			paths: [
				{
					path: '/basicmanage/specialtymange',
					name: '专业管理'
				}
			]
		};
	},
	mounted() {
		this.PageProfLis();
	},
	methods: {
		PageProfLis(pagecrofobj = null) {
			let PageProfobj = {
				pageIndex: 1,
				pageSize: 10,
				pro_name: '',
				si_guid: ''
			};
			if (pagecrofobj) {
				if (!pagecrofobj.si_guid) {
					if (localStorage.getItem('siguid') == 'f760369023c3453bb0917c0869260187') {
						pagecrofobj.si_guid = '';
					}else{
						pagecrofobj.si_guid = localStorage.getItem('siguid');
					}
				}
			}

			// console.log(PageProfobj);
			getPageProfList(pagecrofobj == null ? PageProfobj : pagecrofobj).then(res => {
				// console.log(res)
				this.tablist = res.data.data.list;
				this.pagesobj.maxpages = res.data.data.totalCount;
			});
		}
	},
	components: {
		titles,
		manges
	}
};
</script>

<style lang="less">
/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}
</style>
